module.exports = __webpack_public_path__ + "img/mobi-main.ed86f496.png";